/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSimple } from '../../models/profile-simple';

export interface ListProfileRandom$Params {
  max: number;
  minActivities: number;
}

export function listProfileRandom(http: HttpClient, rootUrl: string, params: ListProfileRandom$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSimple>>> {
  const rb = new RequestBuilder(rootUrl, listProfileRandom.PATH, 'get');
  if (params) {
    rb.path('max', params.max, {});
    rb.path('minActivities', params.minActivities, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileSimple>>;
    })
  );
}

listProfileRandom.PATH = '/rest/profile/random/{max}/{minActivities}';
